// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchMenu":"MU","selections":"NU","pillsDesktopSearchMenu":"OU"};